import { useParams } from 'react-router-dom';
import { Container } from '@occc-app/design-system';
import { usePreparedOfferHook } from '@occc-app/routes/CampaignComponents/component-details/use-prepared-offer.hook';
import { GameDetailsPage } from './GameDetailsPage';
import { getProgramManagementGameDetailsPageHeaderLinks } from '../utils';

export const ProgramManagementGameDetailsPageContainer = () => {
  const { id: offerId = '' } = useParams<{ id: string }>();
  const { loading, error, offer, constraintSupplementalData } = usePreparedOfferHook(offerId);

  const getGameNameToDisplayInBreadcrumb = () => {
    if (error) {
      return 'Something went wrong';
    }

    if (loading && !offer) {
      return 'Loading...';
    }

    if (!offer) {
      return 'Page Not Found';
    }

    return offer.name;
  };

  const links = getProgramManagementGameDetailsPageHeaderLinks(
    getGameNameToDisplayInBreadcrumb(),
    offerId,
  );

  return (
    <Container>
      <GameDetailsPage
        offer={offer}
        constraintSupplementalData={constraintSupplementalData}
        loading={loading}
        error={error}
        links={links}
      />
    </Container>
  );
};
